import { Divider, Grid, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  BCPArrowDownLeft,
  BCPArrowDownRight,
  BCPArrowsLeftRight,
  BCPEllipsis,
  BCPUser,
  BCPUserGroup,
  BCPUsers,
} from "../../../../components/icons/bcp/BCPIcons";
import { hexToRGB } from "../../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";

const IS_GW =
  getEnvironmentVariable("IS_GW") === "true" ||
  getEnvironmentVariable("COMPANY_FLAG") === "gw";

export default function EventTypeCard(props) {
  const { values, setFieldValue, disabled, event, gameSystem } = props;
  const { t } = useTranslation("translation", { keyPrefix: "components.eventCreation" });

  const [eventType, setEventType] = useState(values?.eventType);

  const theme = useTheme();

  useEffect(() => {
    if (values?.eventType !== eventType) setEventType(values?.eventType);
    // eslint-disable-next-line
  }, [values]);

  const getLabelSx = (type) => {
    return {
      color:
        eventType === type
          ? theme?.palette?.link.main
          : disabled
            ? theme?.palette?.text?.disabled
            : "",
      fontWeight: "700",
      fontSize: "20px",
    };
  };
  const getIconSx = (type) => {
    return {
      fontSize: "24px",
      width: "24px",
      color:
        eventType === type
          ? theme?.palette?.link.main
          : disabled
            ? theme?.palette?.text?.disabled
            : "",
    };
  };

  const getContainerSx = (type) => {
    return {
      border: `1px solid ${
        eventType === type
          ? theme?.palette?.link.main
          : theme?.palette?.text?.disabled
      }`,
      borderRadius: ".5rem",
      backgroundColor:
        eventType === type
          ? `rgba(${hexToRGB(theme?.palette?.link.main)}, .15)`
          : disabled
            ? `rgba(${hexToRGB(theme?.palette?.text?.disabled)}, .3)`
            : IS_GW
              ? "#fff"
              : "",

      cursor: !disabled ? "pointer" : "",
      textAlign: "center",
      pb: 2,
      pt: 1,
      pr: [1, 5],
      pl: [0, 5],
      height: "270px",
      "&:hover": {
        backgroundColor: !disabled
          ? `rgba(${hexToRGB(theme?.palette?.text?.disabled)}, .15)`
          : "",
      },
      transition: "background-color 0.2s ease",
    };
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 1,
      }}
    >
      <Grid
        item
        xs={4}
        onClick={() => {
          if (!disabled) {
            setFieldValue("eventType", "Singles Event");
            setFieldValue("doublesEvent", false);
            setFieldValue("teamEvent", false);
          }
        }}
      >
        <Grid container spacing={1} sx={{ ...getContainerSx("Singles Event") }}>
          <Grid item xs={12}>
            <Typography sx={getLabelSx("Singles Event")}>Singles</Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={4}>
            <Typography sx={getLabelSx("Singles Event")}>A</Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={4}>
            <Typography sx={getLabelSx("Singles Event")}>B</Typography>
          </Grid>

          {[...Array(4)].map((el, i) => (
            <>
              <Grid item xs={4}>
                <BCPUser outlined sx={getIconSx("Singles Event")} />
              </Grid>
              <Grid item xs={4}>
                <BCPArrowsLeftRight sx={getIconSx("Singles Event")} />
              </Grid>
              <Grid item xs={4}>
                <BCPUser sx={getIconSx("Singles Event")} />
              </Grid>
            </>
          ))}
        </Grid>
      </Grid>
      <Grid
        item
        xs={4}
        onClick={() => {
          if (!disabled) {
            if (values.eventType === "Teams Event") {
              setFieldValue("playerPlacingMetrics", []);
              if (
                event?.gameSystem?.defaultPairingsMetrics ||
                gameSystem?.defaultPairingsMetrics
              ) {
                setFieldValue(
                  "pairingMetrics",
                  event?.gameSystem?.defaultPairingsMetrics ||
                    gameSystem?.defaultPairingsMetrics
                );
              }
              if (
                event?.gameSystem?.defaultPlacingMetrics ||
                gameSystem?.defaultPlacingMetrics
              ) {
                setFieldValue(
                  "placingMetrics",
                  event?.gameSystem?.defaultPlacingMetrics ||
                    gameSystem?.defaultPlacingMetrics
                );
              }
            }

            setFieldValue("eventType", "Doubles Event");
            setFieldValue("doublesEvent", true);
            setFieldValue("teamEvent", true);
          }
        }}
      >
        <Grid container spacing={1} sx={getContainerSx("Doubles Event")}>
          <Grid item xs={12}>
            <Typography sx={getLabelSx("Doubles Event")}>Doubles</Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={4}>
            <Typography sx={getLabelSx("Doubles Event")}>A</Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={4}>
            <Typography sx={getLabelSx("Doubles Event")}>B</Typography>
          </Grid>

          {[...Array(2)].map((el, i) => (
            <>
              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <BCPUserGroup
                  outlined
                  sx={{
                    fontSize: "30px",
                    width: "30px",
                    color:
                      eventType === "Doubles Event"
                        ? theme?.palette?.link.main
                        : disabled
                          ? theme?.palette?.text?.disabled
                          : "",
                  }}
                />
                <BCPEllipsis sx={getIconSx("Doubles Event")} />
              </Grid>
              <Grid item xs={4}>
                <BCPArrowsLeftRight sx={getIconSx("Doubles Event")} />
              </Grid>
              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <BCPUserGroup
                  sx={{
                    fontSize: "30px",
                    width: "30px",
                    color:
                      eventType === "Doubles Event"
                        ? theme?.palette?.link.main
                        : disabled
                          ? theme?.palette?.text?.disabled
                          : "",
                  }}
                />
                <BCPEllipsis sx={getIconSx("Doubles Event")} />
              </Grid>
            </>
          ))}
        </Grid>
      </Grid>{" "}
      <Grid
        item
        xs={4}
        onClick={() => {
          if (!disabled) {
            setFieldValue(
              "playerPlacingMetrics",
              event?.gameSystem?.defaultPlacingMetrics ||
                gameSystem?.defaultPlacingMetrics
            );

            if (
              event?.gameSystem?.defaultTeamPairingsMetrics ||
              gameSystem?.defaultTeamPairingsMetrics
            ) {
              setFieldValue(
                "pairingMetrics",
                event?.gameSystem?.defaultTeamPairingsMetrics ||
                  gameSystem?.defaultTeamPairingsMetrics
              );
            }
            if (
              event?.gameSystem?.defaultTeamPlacingMetrics ||
              gameSystem?.defaultTeamPlacingMetrics
            ) {
              setFieldValue(
                "placingMetrics",
                event?.gameSystem?.defaultTeamPlacingMetrics ||
                  gameSystem?.defaultTeamPlacingMetrics
              );
            }

            setFieldValue("eventType", "Teams Event");
            setFieldValue("doublesEvent", false);
            setFieldValue("teamEvent", true);
          }
        }}
      >
        <Grid container spacing={1} sx={getContainerSx("Teams Event")}>
          <Grid item xs={12}>
            <Typography sx={getLabelSx("Teams Event")}>Teams</Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={4}>
            <Typography sx={getLabelSx("Teams Event")}>A</Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={4}>
            <Typography sx={getLabelSx("Teams Event")}>B</Typography>
          </Grid>

          <Grid item xs={4}>
            <BCPUsers
              outlined
              sx={{
                fontSize: "32px",
                width: "32px",
                color:
                  eventType === "Teams Event"
                    ? theme?.palette?.link.main
                    : disabled
                      ? theme?.palette?.text?.disabled
                      : "",
              }}
            />
          </Grid>
          <Grid item xs={3} sm={4}>
            <BCPArrowsLeftRight sx={getIconSx("Teams Event")} />
          </Grid>
          <Grid item xs={4}>
            <BCPUsers
              sx={{
                fontSize: "32px",
                width: "32px",
                color:
                  eventType === "Teams Event"
                    ? theme?.palette?.link.main
                    : disabled
                      ? theme?.palette?.text?.disabled
                      : "",
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <BCPArrowDownRight sx={getIconSx("Teams Event")} />
          </Grid>

          <Grid item xs={6}>
            <BCPArrowDownLeft sx={getIconSx("Teams Event")} />
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              sx={{
                border: `1px solid ${
                  eventType === "Teams Event"
                    ? theme?.palette?.link.main
                    : theme?.palette?.text?.disabled
                }`,
                borderRadius: ".5rem",
                p: 1,
                width: ["90%", "80%", "70%", "65%"],
              }}
            >
              {[...Array(2)].map((el, i) => (
                <>
                  <Grid item xs={4}>
                    <BCPUser outlined sx={getIconSx("Teams Event")} />
                  </Grid>
                  <Grid item xs={4}>
                    <BCPArrowsLeftRight sx={getIconSx("Teams Event")} />
                  </Grid>
                  <Grid item xs={4}>
                    <BCPUser sx={getIconSx("Teams Event")} />
                  </Grid>
                </>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1">
          {eventType === "Doubles Event"
            ? t("doublesDescription")
            : eventType === "Teams Event"
              ? t("teamsDescription")
              : t("singlesDescription")}
        </Typography>
      </Grid>
    </Grid>
  );
}
